import { Link } from "react-router-dom";
import useReveal from "../hooks/useReveal";
import { Wand2, Upload, Palette, Eye, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

const steps = [
  { icon: Upload, title: "Snap Your Window", desc: "Upload a photo of the window you'd like to dress." },
  { icon: Palette, title: "Choose a Fabric", desc: "Pick from our curated collection of premium fabrics." },
  { icon: Eye, title: "See Before & After", desc: "Our AI renders your window with the new drapes instantly." },
];

export default function VisualizerCTA() {
  const [ref, inView] = useReveal();

  return (
    <section className="py-24 md:py-32 bg-[#FBF8F3]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div
          ref={ref}
          className={`relative overflow-hidden rounded-3xl bg-[#33291F] px-6 py-14 md:px-16 md:py-20 reveal ${
            inView ? "in-view" : ""
          }`}
        >
          <div className="absolute -bottom-24 -left-16 w-80 h-80 rounded-full bg-[#A17E4A]/20 blur-3xl" />
          <div className="relative grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#A17E4A]/20 border border-[#A17E4A]/40 text-[#E7CFA6] text-xs tracking-widest uppercase mb-6">
                <Wand2 className="w-4 h-4" /> New • AI Powered
              </div>
              <h2 className="font-serif text-3xl md:text-5xl text-white leading-tight mb-5">
                See Your Windows Reimagined
              </h2>
              <p className="text-white/70 text-lg mb-8 max-w-md">
                Not sure how a fabric will look? Try our Drape Visualizer — upload a photo, choose
                your fabric, and see a realistic before &amp; after in seconds.
              </p>
              <Link to="/visualizer">
                <Button className="bg-[#A17E4A] hover:bg-[#8a6a3c] text-white rounded-full px-8 py-6 text-base group">
                  Launch Visualizer
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
            </div>

            <div className="space-y-4">
              {steps.map((s, i) => (
                <div
                  key={s.title}
                  className="flex items-start gap-5 p-5 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors"
                >
                  <div className="w-12 h-12 shrink-0 rounded-xl bg-[#A17E4A] flex items-center justify-center">
                    <s.icon className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h3 className="text-white font-medium text-lg mb-1">
                      <span className="text-[#E7CFA6] mr-2">{i + 1}.</span>
                      {s.title}
                    </h3>
                    <p className="text-white/60">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
